import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

// declare var fbq: Function;

@Component({
  selector: 'app-redirect-store',
  templateUrl: './redirect-store.component.html',
  styleUrls: ['./redirect-store.component.scss']
})
export class RedirectStoreComponent {
constructor(private router: Router, private gtm: GoogleTagManagerService) {}

  ngOnInit(): void {
    const userAgent = navigator.userAgent || navigator.vendor;

    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) || 
                (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

    this.gtm.pushTag({ event: 'app_install', platform: isAndroid ? 'android' : isIOS ? 'ios' : 'web' });

    if (isAndroid) {
      // fbq('track', 'AppInstall');
      window.location.href = 'https://play.google.com/store/apps/details?id=com.solidusystems.nina';
      return;
    }

    if (isIOS) {
      // fbq('track', 'AppInstall');
      window.location.href = 'https://apps.apple.com/app/nina-pasteler%C3%ADa/id6741778585';
      return;
    }

    this.router.navigate(['/home']);
  }
}
